import React, { createContext, useContext, useState } from "react";

const AssessmentContext = createContext();

const SAMPLE_DATA = [
  {
    id: "VD-1001",
    name: "Dr. Asha Rao",
    date: "2025-09-10",
    status: "Accepted",
    remarks: "Strong in USG & CT",
  },
  {
    id: "VD-1002",
    name: "Dr. Kiran Naik",
    date: "2025-08-28",
    status: "Onhold",
    remarks: "Needs training in MRI",
  },
  {
    id: "VD-1003",
    name: "Dr. Ramesh Kumar",
    date: "2025-07-02",
    status: "Rejected",
    remarks: "Insufficient hands-on",
  },
];

export function AssessmentProvider({ children }) {
  const [rows, setRows] = useState(SAMPLE_DATA);

  function addAssessment(data) {
    const newRow = {
      id: `VD-${Math.floor(1000 + Math.random() * 9000)}`,
      name: data.personal.candidateName,
      date: new Date().toISOString().slice(0, 10),
      status: data.hiring.decision,
      remarks: data.notes.overallNotes,
    };
    setRows((prev) => [newRow, ...prev]);
  }

  function updateAssessment(id, data) {
    setRows((prev) =>
      prev.map((item) =>
        item.id === id
          ? {
              ...item,
              name: data.personal.candidateName,
              status: data.hiring.decision,
              remarks: data.notes.overallNotes,
            }
          : item
      )
    );
  }

  return (
    <AssessmentContext.Provider value={{ rows, addAssessment, updateAssessment }}>
      {children}
    </AssessmentContext.Provider>
  );
}

export function useAssessments() {
  return useContext(AssessmentContext);
}